var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24128 0C3.2448 0 0 3.2448 0 7.24128C0 8.40506 0.606036 10.0465 1.49224 11.7595C3.44398 15.5344 6.69655 19.7328 6.69655 19.7328C6.82758 19.9017 7.02844 20 7.24139 20C7.45433 20 7.65604 19.9017 7.78623 19.7328C7.78623 19.7328 11.0379 15.5346 12.9905 11.7595C13.8767 10.0457 14.4828 8.4052 14.4828 7.24128C14.4828 3.2448 11.238 0 7.2415 0H7.24128ZM7.24128 4.13794C5.52835 4.13794 4.13794 5.52846 4.13794 7.24128C4.13794 8.95409 5.52846 10.3446 7.24128 10.3446C8.9541 10.3446 10.3446 8.95409 10.3446 7.24128C10.3446 5.52846 8.9541 4.13794 7.24128 4.13794Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ecaca9661d660eb4732fb6ef75d7adea.svg";
export { ForwardRef as ReactComponent };